<template>
  <b-modal
    id="import-modal"
    v-model="isShowModal"
    title="Xác nhận bàn giao"
    size="xl"
    @hide="handleClose"
  >
    <div class="modal-body">
      <!-- File upload buttons -->
      <b-link style="font-size: 16px; font-weight: 500" v-if="!isUpload"
        >Đây là các thiết bị trong {{ tableData?.length || 0 }} hợp đồng cần xác nhận bàn giao. Bạn
        vui lòng kiểm tra lại trước khi xác nhận duyệt!</b-link
      >

      <!-- Tabs -->
      <div class="mb-3 mt-3">
        <div v-if="!isUpload">
          <div>
            Tổng:
            <strong class="text-primary">{{ tableData?.length || 0 }}</strong>
          </div>

          <b-table
            :busy.sync="loadingComfirm"
            :items="tableData"
            :fields="fields"
            striped
            hover
            sticky-header
            responsive
            :fixed="true"
            :bordered="true"
          >
            <template #cell(index)="data">
              <span>{{ data.index + 1 }}</span>
            </template>
            <template #table-busy>
              <div class="text-center my-2">
                <b-spinner class="align-middle" />
              </div>
            </template>
            <template #empty>
              <div class="text-center text-info my-2">Không có dữ liệu</div>
            </template>
            <template #emptyfiltered="{ emptyFilteredText }">
              <h4>{{ emptyFilteredText }}</h4>
            </template>

            <template #cell(serial)="{ item }">
              <span>{{ item?.serialDevices?.join(', ') }}</span>
            </template>
            <template #cell(merchant)="{ item }">
              <p>{{ item?.mechantInfo?.name }}</p>
              <p>{{ item?.mechantInfo?.email }}</p>
            </template>
          </b-table>
        </div>

        <b-tabs v-model="activeTab" v-if="isUpload">
          <template #tabs-end>
            <div style="display: flex; justify-content: space-between">
              <input
                v-model="txtSearch"
                type="text"
                class="input-search d-inline-block"
                style="
                  width: 200px;
                  height: 25px;
                  text-indent: 5px;
                  margin-top: 10px;
                  border: none;
                  border-left: 1px solid #638cea;
                  margin-left: 10px;
                "
                placeholder="🔎 Từ khóa"
              />
            </div>
          </template>
          <b-tab title="Thành công">
            <template v-slot:title> Thành công({{ successCount }}) </template>
            <div>
              <div class="mt-2 mb-1">
                Tổng: <b class="text-primary">{{ successCount }}</b>
              </div>
              <b-table
                :items="filteredSuccessItems"
                :fields="fields"
                striped
                hover
                sticky-header
                responsive
                :fixed="true"
                :bordered="true"
                :busy.sync="loadingComfirm"
              >
                <template #cell(index)="data">
                  <span>{{ data.index + 1 }}</span>
                </template>
                <template #table-busy>
                  <div class="text-center my-2">
                    <b-spinner class="align-middle" />
                  </div>
                </template>
                <template #empty>
                  <div class="text-center text-info my-2">Không có dữ liệu</div>
                </template>
                <template #emptyfiltered="{ emptyFilteredText }">
                  <h4>{{ emptyFilteredText }}</h4>
                </template>
                <template #cell(serial)="{ item }">
                  <span>{{ item?.serials?.join(', ') }}</span>
                </template>
                <template #cell(merchant)="{ item }">
                  <p>{{ item?.merchantName }}</p>
                  <p>{{ item?.merchantEmail }}</p>
                </template>
              </b-table>
            </div>
          </b-tab>

          <b-tab title="Thất bại">
            <template v-slot:title> Thất bại ({{ failedCount }}) </template>
            <div>
              <div class="mt-2 mb-1">
                Tổng: <b class="text-primary">{{ failedCount }}</b>
              </div>
              <b-table
                :items="filteredFailedItems"
                :fields="filedError"
                striped
                hover
                sticky-header
                responsive
                :fixed="true"
                :bordered="true"
                :busy.sync="loadingComfirm"
              >
                <template #cell(index)="data">
                  <span>{{ data.index + 1 }}</span>
                </template>
                <template #cell(merchant)="{ item }">
                  <p>{{ item?.merchantName }}</p>
                  <p>{{ item?.merchantEmail }}</p>
                </template>
                <template #table-busy>
                  <div class="text-center my-2">
                    <b-spinner class="align-middle" />
                  </div>
                </template>
                <template #empty>
                  <div class="text-center text-info my-2">Không có dữ liệu</div>
                </template>
                <template #emptyfiltered="{ emptyFilteredText }">
                  <h4>{{ emptyFilteredText }}</h4>
                </template>
                <template #cell(action)="{ item }">
                  <b-button class="ml-2" variant="success" @click="handleConfirmOne(item)">
                    {{ loadingOneComfirm === item.contractId ? 'Đang duyệt...' : 'Duyệt lại' }}
                  </b-button>
                </template>
                <template #cell(serial)="{ item }">
                  <span>{{ item?.serials?.join(', ') }}</span>
                </template>
              </b-table>
            </div>
          </b-tab>
        </b-tabs>
      </div>
    </div>

    <template #modal-footer>
      <b-button variant="light" @click="handleClose"> Hủy </b-button>
      <b-button
        :disabled="loadingComfirm"
        variant="primary"
        v-if="!isUpload"
        @click="handleConfirmAll"
      >
        {{ loadingComfirm ? 'Đang duyệt...' : 'Xác nhận' }}
      </b-button>
      <b-button v-if="activeTab === 1 && isUpload" variant="primary" @click="retryAll">
        {{ loadingComfirm ? 'Đang duyệt...' : 'Duyệt lại tất cả' }}
      </b-button>
    </template>
  </b-modal>
</template>

<script>
  import { showMess } from '@/config/utils'
  import { DeviceService } from '../../../../services/device.service'

  export default {
    name: 'PopupComfirm',
    props: ['onLoad'],
    data() {
      return {
        isShowModal: false,
        loadingComfirm: false,
        loadingOneComfirm: null,
        isUpload: false,

        txtSearch: '',
        activeTab: 0,
        isComfirm: false,
        tableData: [],
        tableDataRes: [],
        fields: [
          {
            key: 'index',
            label: 'STT',
            tdClass: 'text-center',
            thClass: 'text-center',
            thStyle: 'width: 80px',
          },
          { key: 'contractCode', label: 'Mã hợp đồng' },
          { key: 'serial', label: 'Thiết bị' },
          { key: 'merchant', label: 'Merchant' },
        ],
      }
    },

    computed: {
      // Filter items thành công
      filteredSuccessItems() {
        const searchTerm = this.txtSearch.toLowerCase().trim()
        if (!searchTerm) return this.successItems

        return this.successItems.filter(item => {
          return (
            item.serial?.toLowerCase().includes(searchTerm) ||
            item.contractCode?.toLowerCase().includes(searchTerm) ||
            item.merchantName?.toLowerCase().includes(searchTerm) ||
            item.merchantEmail?.toLowerCase().includes(searchTerm) ||
            item.mechantInfo?.toLowerCase().includes(searchTerm)
          )
        })
      },

      // Filter items thất bại
      filteredFailedItems() {
        const searchTerm = this.txtSearch.toLowerCase().trim()
        if (!searchTerm) return this.failedItems

        return this.failedItems.filter(item => {
          return (
            item.serial?.toLowerCase().includes(searchTerm) ||
            item.contractCode?.toLowerCase().includes(searchTerm) ||
            item.merchantName?.toLowerCase().includes(searchTerm) ||
            item.merchantEmail?.toLowerCase().includes(searchTerm) ||
            item.reason?.toLowerCase().includes(searchTerm) ||
            item.mechantInfo?.toLowerCase().includes(searchTerm)
          )
        })
      },
      filedError() {
        return [
          ...this.fields,
          { key: 'mess', label: 'Lý do lỗi' },
          { key: 'action', label: 'Hành dộng', thStyle: 'width: 140px' },
        ]
      },
      //
      successItems() {
        return this.tableDataRes?.success || []
      },
      failedItems() {
        return this.tableDataRes?.fails || []
      },

      successCount() {
        return this.successItems?.length || 0
      },
      failedCount() {
        return this.failedItems?.length || 0
      },
    },
    filters: {
      // lấy ngày, giờ
      formatTime(text) {
        if (!text) return
        return text?.replace(/(\d{4})-(\d{2})-(\d{2})/, '$3/$2/$1')
      },
    },
    methods: {
      // show modal
      show(data) {
        const newData = data.map(item => {
          return {
            ...item,
            mechantInfo: {
              name: item.merchantName || '',
              email: item.merchantEmail || '',
              serials: item.serialDevices || [],
            },
          }
        })
        this.getListPaser(newData)
        this.isShowModal = true
      },

      resetFileInput() {
        if (this.$refs.fileInput) {
          this.$refs.fileInput.value = ''
        }
      },
      async getListPaser(data) {
        this.loadingComfirm = true
        try {
          const res = await DeviceService.listDevicePaser(data)
          if (res.code === 1000) {
            this.tableData = res?.data || []
          } else {
            showMess(
              this,
              'Error',
              res.message || 'Lỗi xác nhận duyệt',
              'danger',
              'b-toaster-top-right',
              5 * 60 * 60
            )
          }
        } catch (error) {
          showMess(this, 'Error', error.message, 'danger', 'b-toaster-top-right', 5 * 60 * 60)
        } finally {
          this.loadingComfirm = false
        }
      },

      // đóng modal
      handleClose() {
        this.isShowModal = false
        this.resetData()
        this.isUpload = false
      },
      // cài đặt lại trạng thái state
      resetData() {
        this.activeTab = 0
        this.tableData = []
      },
      async handleConfirmOne(item) {
        this.loadingOneComfirm = item.contractId
        const payload = [
          {
            action: 'SUCCESS',
            ...item,
            merchantName: item.mechantInfo?.name,
            merchantEmail: item.mechantInfo?.email,
            serials: item.serialDevices || [],
          },
        ]
        this.confirmData(payload, false)
      },

      retryAll() {
        const payload =
          this.failedItems.map(item => ({
            action: 'SUCCESS',
            ...item,
            merchantName: item.mechantInfo?.name,
            merchantEmail: item.mechantInfo?.email,
          })) || []
        this.confirmData(payload)
      },
      async confirmData(payload, isSetData = true) {
        if (isSetData) {
          this.loadingComfirm = true
        }

        try {
          const res = await DeviceService.comfirmDeviceHandover(payload)
          if (res.code === 1000) {
            if (isSetData) {
              // this.tableDataRes = res?.data || []
              this.tableDataRes = {
                success: [...(this.tableDataRes?.success || []), ...(res?.data?.success || [])],
                fails: res?.data?.fails || [],
              }
              showMess(
                this,
                'Đã gửi duyệt',
                `Có ${res?.data?.success?.length || 0} thành công và ${res?.data?.fails?.length || 0} thất bại`,
                'success',
                'b-toaster-top-right',
                5 * 60 * 60
              )
            } else {
              if (res?.data?.fails[0]?.mess) {
                showMess(
                  this,
                  'Thông báo',
                  res?.data?.fails[0]?.mess || res.message,
                  'danger',
                  'b-toaster-top-right',
                  5 * 60 * 60
                )
              } else {
                const successItem = res?.data?.success[0]
                if (successItem) {
                  this.tableDataRes = {
                    success: [...(this.tableDataRes?.success || []), successItem],
                    fails: (this.tableDataRes?.fails || []).filter(
                      item => item.contractId !== successItem.contractId
                    ),
                  }
                }
                showMess(
                  this,
                  'Thông báo',
                  res?.data?.success[0]?.mess || res.message,
                  'success',
                  'b-toaster-top-right',
                  5 * 60 * 60
                )
              }
            }
            this.loadingOneComfirm = null
            this.isUpload = true
            if (res.data?.success?.length > 0) {
              this.$emit('onLoad')
            }
            if (res.data.success?.length > 0 && res.data.fails?.length <= 0 && isSetData) {
              this.isShowModal = false
            }
          } else {
            showMess(
              this,
              'Error',
              res.message || 'Lỗi xác nhận duyệt',
              'danger',
              'b-toaster-top-right',
              5 * 60 * 60
            )
          }
        } catch (error) {
          showMess(this, 'Error', error.message, 'danger', 'b-toaster-top-right', 5 * 60 * 60)
        } finally {
          this.loadingComfirm = false
        }
      },

      async handleConfirmAll() {
        const payload =
          this.tableData.map(item => ({
            action: 'SUCCESS',
            ...item,
            merchantName: item.mechantInfo?.name,
            merchantEmail: item.mechantInfo?.email,
            serials: item.serialDevices || [],
          })) || []
        this.confirmData(payload)
      },
    },
  }
</script>

<style lang="scss" scoped>
  .modal-body {
    padding-top: 0;
    max-height: 75vh;
    height: 75vh;
    overflow-y: auto;
    .radio-group {
      display: flex;
      justify-items: center;
    }
  }
  :deep(.modal-xl) {
    max-width: 1200px;
  }
  :deep(.b-table-sticky-header) {
    max-height: 66vh !important;
  }
</style>
